import React from 'react';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { UserAvatar } from '@/components/UserAvatar';

export const AdminAccountAvatar = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	return <UserAvatar userId={userDetails?.userId} width={24} height={24} />;
};

export const AdminAccountLabel = () => {
	const account = useSelector((state) => state.msalAccount.account);
	return account?.username ?? '';
};
